import {
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
  type SupportedLanguage,
} from "@/utils/library/languages";

export type GlobalErrorCopy = {
  title: string;
  description: string;
  tryAgain: string;
};

type CommonLocaleFile = {
  globalError: GlobalErrorCopy;
};

function resolveLocale(lang: string): SupportedLanguage {
  if ((SUPPORTED_LANGUAGES as readonly string[]).includes(lang)) {
    return lang as SupportedLanguage;
  }
  return DEFAULT_LANGUAGE;
}

/** Loads `globalError` from public locale files without bundling every common.json. */
export async function loadGlobalErrorCopy(lang: string): Promise<GlobalErrorCopy> {
  const locale = resolveLocale(lang);
  const response = await fetch(`/locales/${locale}/common.json`);

  if (!response.ok) {
    throw new Error(
      `Failed to load global error copy for locale "${locale}" (${response.status})`,
    );
  }

  const common = (await response.json()) as CommonLocaleFile;
  return common.globalError;
}
